var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg_nav_containner"},[_c('img',{staticClass:"img_logo",attrs:{"src":"https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/logo.png","alt":""}})])
}]

export { render, staticRenderFns }